import * as React from "react";
import { Link } from "gatsby";

import Layout from "../../components/Layout";
import Seo from "../../components/Seo";

import Old2005BlogPage from "../../components/Old2005BlogPage";

const OldBlogPage = () => (
  <Layout>
    <Seo title="Old 2005 Blog—January 2005" />
	<Old2005BlogPage>
		<h2>January 2005</h2>



	<h3 className="blogdate">
	Sunday, January 30, 2005
	</h3>
	<h4 className="blogitemtitle">
	Deadbeat Blues
	</h4>
		<div className="blogitembody">
		I just uploaded a new (old) song:  <em>Deadbeat Blues</em>.  I wrote it last summer and today I chose to make a quick <em>Stinksound</em> recording of it for your listening pleasure!  However, if you don't like swear words and (im)mature subject matter, then consider yourself warned:  this song contains both.
<br />
<br />Links:
<br /><Link to="/music/">http://www.jesserivest.com/music/</Link>
<br />
		</div>
		<div className="blogitemfooter">
		posted by Jesse @ 7:43 PM &nbsp;
		</div>





	<h3 className="blogdate">
	Friday, January 28, 2005
	</h3>
	<h4 className="blogitemtitle">
	Open stage at the Ironwood
	</h4>





		<div className="blogitembody">
		The <em>Ironwood Stage and Grill</em> is a very smoke-free environment! I went to the Open Stage last night, hosted by Brian McAreavey. Pints were only $4 and wings were $0.25 each, and the atmosphere and sound is great. Aaron Young joined me with some of his friends; originally I thought Aaron wanted to play but I think he came just for beer and to "support his student" (he teaches me guitar lessons). That was pretty cool of him!
<br />
<br />I didn't note any honorable mentions this time, but the attendance was good and the last performer probably didn't finish until 12:30. I personally want to attend more than one open mic per week so I think I will look for more venues. I want to become more comfortable performing by myself and learn to beat performance anxiety. Anxiety is a mental issue, however there is a physiological response that results, making it difficult to perform at your full capability. Gotta learn to deal with it and play like no-one is listening! Or like it doesn't matter who is listening, because really... it doesn't matter. I enjoy playing, and I play to satisfy my soul.
<br />
<br />Links:
<br /><a href="http://www.ironwoodstage.ca/">http://www.ironwoodstage.ca/</a>
<br />
		</div>
		<div className="blogitemfooter">
		posted by Jesse @ 6:15 AM &nbsp;
		</div>





	<h3 className="blogdate">
	Wednesday, January 26, 2005
	</h3>
	<h4 className="blogitemtitle">
	Dragon and Kitty back online
	</h4>





		<div className="blogitembody">
		Okay, so <em>Dragon and Kitty</em> is back online, I managed to record the song closer to how I've been playing it... although I mixed the order of the last two verses!  I don't care; it's hard for me to deliver the lyrics without error.  Let me know your thoughts if you listen to it!
<br />
<br />Links:
<br /><Link to="/music/">http://www.jesserivest.com/music/</Link>
<br />
		</div>
		<div className="blogitemfooter">
		posted by Jesse @ 4:46 PM &nbsp;
		</div>





	<h3 className="blogdate">
	Tuesday, January 25, 2005
	</h3>
	<h4 className="blogitemtitle">
	Dragon and Kitty in the works
	</h4>





		<div className="blogitembody">
		I chose to remove the link to <em>Dragon and Kitty</em>, but only temporarily while I revise the lyrics and rework the song.  I put it up a bit too early; I know some people already heard it but the new version will come soon.
<br />
<br />I'm probably going to the Ironwood this Wednesday night for open mic...
<br />
		</div>
		<div className="blogitemfooter">
		posted by Jesse @ 2:27 PM &nbsp;
		</div>





	<h3 className="blogdate">
	Saturday, January 22, 2005
	</h3>
	<h4 className="blogitemtitle">
	Lester Quitzau and Mae Moore in Banff
	</h4>





		<div className="blogitembody">
		I bought my ticket to see Lester and Mae perform at The Banff Centre (for Performing Arts); the date of the show is February 18, 2005.  It starts at 8:00 pm so I can make it to Banff (from Calgary) after work.  They're playing in Calgary, as well as some other Alberta locations, so check out Lester's website for dates and times.  I'd prefer to go to Banff to see the show; it will cost me more but it's near my birthday so who cares.
<br />
<br />Links:
<br /><a href="http://www.banffcentre.ca/">http://www.banffcentre.ca/</a>
<br /><a href="http://www.lesterq.com/">http://www.lesterq.com/</a>
<br /><a href="http://www.maemoore.com/">http://www.maemoore.com/</a>
<br />
		</div>
		<div className="blogitemfooter">
		posted by Jesse @ 7:02 AM &nbsp;
		</div>





	<h3 className="blogdate">
	Friday, January 21, 2005
	</h3>
	<h4 className="blogitemtitle">
	New Song: Dragon and Kitty
	</h4>





		<div className="blogitembody">
		I wrote a new song over the last couple days and I have updated my music page.  It's a groovy yet goofy song, I know, but it is different from anything I've ever written so I am happy.  If you want to hear it just send me an email for the username and password.
<br />
<br />Links:
<br /><Link to="/blog2005/">http://www.jesserivest.com/music/</Link>
<br />
		</div>
		<div className="blogitemfooter">
		posted by Jesse @ 7:28 PM &nbsp;
		</div>
	<h4 className="blogitemtitle">
	Karma was packed last night
	</h4>





		<div className="blogitembody">
		I showed up at <em>Karma</em> around 9:00 and was lucky to find a seat at the bar; all the tables were already filled.  Everyone who piled in after me was left standing, and there were lots of names in the jar (it's a draw to see who plays next).  By the time midnight came, my name had not been called yet; I was tired and my lungs and eyes were burning from the thick smoky haze that persisted the entire night.  My homing device kicked in and I left, had a shower at home and passed out.  I am very tired today.
<br />
<br />There was one fellow who played that sticks in my mind:  Mike Lynch (spelling?).  This guy was from Ontario, now residing in Calgary, and wrote some hilarious country-style songs.  The way he delivered the songs, and the lyrics within, were awesome!  He had a great voice, and he fit the part with his long hair, overalls and cowboy boots.  While he played he jigged his leg/foot to the tune, and would alternate back and forth between legs/feet like he was dancing at a rodeo show!  In no way am I making fun of him - his tunes and delivery were very memorable!  He'd obviously been at it for a while becuase he had a CD with him that you could purchase.
<br />
<br />I think next week I might try <em>Ironwood </em>instead; I believe it is less busy and less smoky.  I do like the popularity of <em>Karma</em>, but I also want a sure chance to get up and play.  I'll probably alternate between the two for a while.
<br />
<br />Links:
<br /><a href="http://www.coollittlelounge.com/">http://www.coollittlelounge.com/</a>
<br /><a href="http://www.ironwoodstage.ca/">http://www.ironwoodstage.ca/</a>
<br />
		</div>
		<div className="blogitemfooter">
		posted by Jesse @ 7:14 AM &nbsp;
		</div>





	<h3 className="blogdate">
	Friday, January 14, 2005
	</h3>
	<h4 className="blogitemtitle">
	Lester Quitzau tour dates
	</h4>





		<div className="blogitembody">
		It looks like Lester Quitzau has some new tour dates; I'm excited because they are in the next month and near my home in Calgary!  I think it will be Lester unplugged as he is touring with Mae Moore, but it will still be great!
<br />
<br />Links:
<br /><a href="http://www.lesterq.com/">http://www.lesterq.com/</a>
<br />
		</div>
		<div className="blogitemfooter">
		posted by Jesse @ 4:51 PM &nbsp;
		</div>
	<h4 className="blogitemtitle">
	Open Mic at Karma Local Arts House
	</h4>





		<div className="blogitembody">
		So I made it to <em>Karma Local Arts House</em> last night for open mic night, but <em>Mike Robinson</em> was a bit late to host the show. Turns out he couldn't start his truck, it was -30 and mine didn't start easily, as well! He did make it and he started the show around 9:30, playing a few songs including his own <em>Tango</em>, which I've heard before and really enjoy. I met a fellow named Kevin, who recently returned to Canada after teaching English in Seoul, Korea. He played a few hilarious songs that he wrote; one about driving Deerfoot Trail to get some <em>Cheetos</em>, another about trying to get close to a girl he likes during a wild orgy, and I can't remember the third. He was very good - he has a fearless ability to perform and I later discovered he is an actor.<br /><br />By the time I was up to play, <em>No Woman No Cry</em> had already been covered so I chose to do just two songs. I could have also played the song because my playing style was very different, but oh well. I set the guitar on my lap and pulled out my slide, and started off with <em>Talks to Angels</em> by the <em>Black Crowes</em>. That seemed to grab everyone's attention so I went on to <em>Solace Amongst the Sin</em> by <em>Xavier Rudd</em>, and I seemed to lose a few people to conversation. But the song was still well received by most and I was happy. A fellow, Bill, at the bar next to me chose to say that my playing was refreshing, a cool style, and I produced a good mood.<br /><br />Later a fellow named Dave rapped while his friends played guitar, I thought he had a cool voice. He later played the guitar himself and sang a song or two that he wrote; they were cool and definitely in his own style. On my way out the door he commented that my "<em>Jeff Healy"</em> playing was cool, so I thanked him and told him I'd like to hear his stuff again sometime. I think I was playing more like <em>Xavier Rudd</em> than <em>Jeff Healy</em>, but oh well.<br /><br />I didn't get to bed until 1:00 am, and I slept in a bit this morning. It was f#$%ing cold this morning; I chose to take the bus to work because I was late, but if I would have walked I would have only been 15 minutes later and a lot less frustrated (with the bus). Next time. Good thing I have all my snowboard gear to keep me warm.<br /><br />Links:<br /><a href="http://www.xavierrudd.com/">http://www.xavierrudd.com/</a><br /><a href="http://www.coollittlelounge.com/">http://www.coollittlelounge.com/</a>
		</div>
		<div className="blogitemfooter">
		posted by Jesse @ 9:32 AM &nbsp;
		</div>





	<h3 className="blogdate">
	Monday, January 10, 2005
	</h3>
	<h4 className="blogitemtitle">
	Sillan & Young at the Ironwood Stage
	</h4>





		<div className="blogitembody">
		Last night I took in a jazzy performance by <em>Sillan & Young</em>, at the <em>Ironwood Stage and Grill</em> in Calgary. I saw the group play before, over a year ago and before their album was released, at the <em>Beat Niq</em> - the material (from the album <em>Better Thing</em>) was great then and is even better now. Many fun and upbeat songs have been added to the repertoire to allow two full sets of tunes over a couple hours of playing time. All material played had an excellent feel and sound.<br /><br />I didn't take notes, but a couple of highlight covers were played that I should mention. First, Aaron and Johanna did a jazz-fusioned medley of Jimi Hendrix tunes, including <em>Little Wing</em>. Second, Aaron, Rob and Kodi did a very jazzy cover of a Nirvana tune... I think it was <em>Come as You Are</em>. Very cool! The three of them also broke into some old style blues/jazz playing that gave Aaron an opportunity to dazzle the crowd with his masterment of the guitar and fretboard - virtuosic yet highly tasteful.<br /><br />I've been fortunate to receive some guitar lessons from Aaron in the past year; I was glad he notified me of this gig because it is highly inspiring to watch him play. The whole crew is excellent; Johanna's singing and voice are romantically smooth and strong, while it appears that Rob and Kodi have been doing tight rhythm together for a long time.<br /><br />Aaron invited some folks to his house/studio after the show, so I brought my guitar along and stayed for a couple Grasshoppers (beer). His wife, Roxanne, has acquired a beautiful 250-year-old violin, and before long she was playing celtic and jazzy melodies over Aaron's rhythm while I tried to keep up with the changes. I was out of my league and I handed my guitar to Al (roommate and friend of Aaron) who had a better time following along. That violin sounded incredible! 4:00 am came quick and I left for bed, but I think those guys probably stayed up all night, jamming and listening to tunes. Good time!<br /><br />Links:<br /><a href="http://sillanyoung.com/">http://sillanyoung.com/</a><br /><a href="http://www.ironwoodstage.ca/">http://www.ironwoodstage.ca/</a><br /><a href="http://www.beatniq.com/">http://www.beatniq.com/</a>
		</div>
		<div className="blogitemfooter">
		posted by Jesse @ 9:21 AM &nbsp;
		</div>



		<p>
			<Link to="/blog2005/">Go back to the blog index page</Link>
		</p>
</Old2005BlogPage>
  </Layout>
)

export default OldBlogPage;
